import { render, staticRenderFns } from "./YearChart.vue?vue&type=template&id=952c09c0&scoped=true"
import script from "./YearChart.vue?vue&type=script&lang=js"
export * from "./YearChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952c09c0",
  null
  
)

export default component.exports